import { gql } from "@apollo/client";

const UPDATE_BRANDING = gql`
  mutation Branding($input: UpdateBranding) {
    updateBranding(input: $input) {
      status
      data
      error
    }
  }
`;

export default UPDATE_BRANDING;
